import GetTextContentPagedListRequestModelBase from '../_generated/modelBases/get-text-content-paged-list-request-model-base';

export default class GetTextContentPagedListRequestModel extends GetTextContentPagedListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
